/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectDefinition} from "../models/object-definition";
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {ObjectCategory} from "../models/object-category";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class DevicesPagingResolver implements Resolve<PagedResults<ObjectDefinition>> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<ObjectDefinition>> {
    try {
      return await this.mObjectService.getAllObjectsForCategoryPaging(ObjectCategory.DEVICE, 0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Device Types... Error: " + error, error);
    }
  }

}
